import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { NavigationTypeContext, useNavigationType } from '../context.js';
import { useMaturityLevel } from '../../../component-maturity.js';


const Menu = (props) => {
  useMaturityLevel('stable', 'Navigation.Menu');
  const { as: Component, primary, utility, context, className, right, ...rest } = props;
  const navigationType = useNavigationType(props);
  const menuClasses = classnames(
    'particles-navigation-menu',
    `particles-navigation-menu--${navigationType}`,
    className, {
      [`particles-navigation-menu--${navigationType}-right`]: !!right,
      [`particles-navigation-menu--${navigationType}-left`]: !right,
      'particles-navigation-menu--left': !right,
      'particles-navigation-menu--right': !!right
    }
  );
  return (
    <NavigationTypeContext {...props}>
      <Component className={menuClasses} {...rest} />
    </NavigationTypeContext>
  );
};

Menu.defaultProps = {
  as: 'div',
  primary: false,
  utility: false,
  right: false
};
Menu.propTypes = {
  /** Right justify menu */
  right: PropTypes.bool,
  /** Enable primary styling */
  primary: PropTypes.bool,
  /** Enable utility styling */
  utility: PropTypes.bool,
  /** Enable context styling */
  context: PropTypes.bool,
  /** Extra classes */
  className: PropTypes.string,
  /** String or function to transform the component into. ie: Button, 'div', 'section', 'nav' */
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.elementType])
};
Menu.displayName = 'Navigation.Menu';

export default Menu;

export const {
  defaultProps,
  propTypes,
  displayName
} = Menu;
